export default "__VITE_ASSET__BQWFRoJV__"